export default __webpack_public_path__ + "static/media/gmailIcon.3545e5cd.png";